import styled from 'styled-components'

const Columns = styled.div `
  display: flex;
  margin-left: -30px;

  @media screen and (max-width: 640px) {
    flex-direction: column;
    margin-left: 0px;
  }
`

Columns.Column = styled.div `
  margin-left: 30px;
  @media screen and (max-width: 640px) {
    margin-left: 0px;
  }
  flex-grow: 1;
  box-sizing: border-box;
`

export { Columns }
